import { render, staticRenderFns } from "./StoreBody.vue?vue&type=template&id=05f53138&scoped=true&"
import script from "./StoreBody.vue?vue&type=script&lang=ts&"
export * from "./StoreBody.vue?vue&type=script&lang=ts&"
import style0 from "./StoreBody.vue?vue&type=style&index=0&id=05f53138&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f53138",
  null
  
)

export default component.exports